<template>
    <div class="top-border">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1360 20">
            <g fill="none" fill-rule="evenodd">
                <path fill="#18A035" :d="'M1027.228 20H1360V0h-332.772z'"/>
                <path fill="#0077BD" d="M989.272 20h37.956V0h-37.956z"/>
                <path fill="#CC0B0A" d="M765.768 20h223.504V0H765.768z"/>
                <path fill="#F39100" d="M440.371 20h325.397V0H440.371z"/>
                <path fill="#201C17" d="M384.744 20h55.627V0h-55.627z"/>
                <path fill="#E41E0A" d="M0 20h384.744V0H0z"/>
            </g>
        </svg>
    </div>
</template>